import { ComponentStyleConfig } from "@chakra-ui/react";
import { ThemeColor } from "../palette";

export const Link: ComponentStyleConfig = {
    baseStyle: {
        textColor: "white",
        _hover: {
            color: ThemeColor.KAIROS,
            textDecoration: "none",
            "& svg": {
                fill: ThemeColor.KAIROS,
            },
        },
    },
};
